import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, DataTable, Empty, Muted, PageHeader, Section } from '@/components/ui'
import { fetchOnboardingMaps } from './api'

export function OnboardingShadowPage() {
  const maps = useQuery({ queryKey: ['wi', 'onboarding'], queryFn: fetchOnboardingMaps })
  const rows = maps.data || []

  return (
    <section className="hi-page">
      <PageHeader
        title="Modo sombra"
        subtitle="Mapas de onboarding via Flow Intelligence."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/onboarding-shadow')}>
            Legado
          </a>
        }
      />
      <Section title="Mapas" flush>
        {maps.isLoading ? <Muted>Carregando…</Muted> : null}
        {maps.isError ? (
          <Alert tone="danger">
            {maps.error instanceof ApiError ? maps.error.message : 'Falha ao listar onboarding.'}
          </Alert>
        ) : null}
        {!maps.isLoading && rows.length === 0 ? <Empty>Nenhum mapa gerado.</Empty> : null}
        {rows.length > 0 ? (
          <DataTable>
            <thead>
              <tr>
                <th>Colaborador</th>
                <th>Cargo</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={String(r.id || i)}>
                  <td>{String(r.colaborador_nome || r.colaborador || '—')}</td>
                  <td>{String(r.cargo_nome || r.cargo || '—')}</td>
                  <td>{String(r.status || '—')}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        ) : null}
      </Section>
    </section>
  )
}
